import { isVisible } from "@/components/viewer/Mesh";
import * as THREE from "three";
export function startListeners() {
  document.addEventListener("mousehold", onMouseMove);
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mousedown", onMouseDown);
  document.addEventListener("mouseup", onMouseUp);
  document.addEventListener("keydown", onKeyDown);
  document.addEventListener("keyup", onKeyUp);
}

//#region local var
const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();
let camera, scene, webGLRenderer, activeCameraIndex;
let isInitialized = false;
let hoveredObject;
const holdTimeToStart = 75; // in mil sec
let holdTimeOut;
let customEventID = 0;
const eventsName = {
  MOVE: "mousemove",
  OUT: "mouseout",
  HOVER: "mouseover",
  DOWN: "mousedown",
  HOLD: "mousehold",
  DRAG: "mousedrag",
  UP: "mouseup",
  KEYDOWN: "keydown",
  KEYUP: "keyup",
};
const eventListenerObject = []; // [layer] [object uuid] [event name] [function]
//#endregion
const layers = [];
export function initializeClickManager(
  scene,
  cam,
  webGLRenderer,
  activeCameraIndex,
) {
  if (!isInitialized) {
    startListeners();
    isInitialized = true;
  }
  setWebGLRenderer(webGLRenderer);
  setCamera(cam);
  setScene(scene);
  setActiveCameraIndex(activeCameraIndex);
}
export function setActiveCameraIndex(_activeCameraIndex) {
  activeCameraIndex = _activeCameraIndex;
}
export function setWebGLRenderer(_webGLRenderer) {
  if (!_webGLRenderer) {
    console.log("_webGLRenderer can't be null");
  }
  webGLRenderer = _webGLRenderer;
}
function setCamera(cam) {
  if (!cam) {
    console.log("camera can't be null");
  }
  camera = cam;
}
function setScene(_scene) {
  if (!_scene) {
    console.log("scene can't be null");
  }
  scene = _scene;
}
export function addEventListener(object, eventName, action, layer = 1) {
  if (!eventName || !action) {
    console.log("missing provided Data");
  }
  if (!eventListenerObject[layer]) {
    layers.push(layer);
    eventListenerObject[layer] = {};
  }
  if (!object) {
    while (eventListenerObject[layer].hasOwnProperty(customEventID)) {
      customEventID++;
    }
    object = { uuid: customEventID++ };
  }
  if (!eventListenerObject[layer][object.uuid]) {
    eventListenerObject[layer][object.uuid] = {};
  }
  eventListenerObject[layer][object.uuid][eventName] = action;
  eventListenerObject[layer][object.uuid].object = object;

  return object.uuid;
}

function onKeyDown(logKey) {
  if (!eventListenerObject[1]) {
    return;
  }
  if (Object.keys(eventListenerObject[1]).length === 0) {
    return;
  }
  const objectKeys = Object.keys(eventListenerObject[1]);

  for (let i = 0; i < objectKeys.length; i++) {
    if (
      eventListenerObject[1][objectKeys[i]].hasOwnProperty(eventsName.KEYDOWN)
    ) {
      eventListenerObject[1][objectKeys[i]][eventsName.KEYDOWN](logKey);
    }
  }
}

function onKeyUp(logKey) {
  if (!eventListenerObject[1]) {
    return;
  }

  if (Object.keys(eventListenerObject[1]).length === 0) {
    return;
  }
  const objectKeys = Object.keys(eventListenerObject[1]);

  for (let i = 0; i < objectKeys.length; i++) {
    if (
      eventListenerObject[1][objectKeys[i]].hasOwnProperty(eventsName.KEYUP)
    ) {
      eventListenerObject[1][objectKeys[i]][eventsName.KEYUP](logKey);
    }
  }
}

function onMouseMove(mouseInfo) {
  let hasHovered = false;
  layers.forEach(layerIndex => {
    if (!hasHovered) {
      if (Object.keys(eventListenerObject[layerIndex]).length === 0) {
        return;
      }

      let rect = webGLRenderer.domElement.getBoundingClientRect();

      pointer.x =
        ((mouseInfo.clientX - rect.left) / (window.innerWidth - rect.left)) *
          2 -
        1;
      pointer.y =
        -((mouseInfo.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
      const objectKeys = Object.keys(eventListenerObject[layerIndex]);
      raycaster.setFromCamera(pointer, scene.children[activeCameraIndex]);

      let raycasterList = [];
      for (let i = 0; i < objectKeys.length; i++) {
        if (
          eventListenerObject[layerIndex][objectKeys[i]]?.hasOwnProperty(
            eventsName.MOVE,
          ) ||
          eventListenerObject[layerIndex][objectKeys[i]]?.hasOwnProperty(
            eventsName.HOVER,
          ) ||
          eventListenerObject[layerIndex][objectKeys[i]]?.hasOwnProperty(
            eventsName.OUT,
          )
        ) {
          if (!eventListenerObject[layerIndex][objectKeys[i]].object.name) {
            eventListenerObject[layerIndex][objectKeys[i]][eventsName.MOVE](
              objectKeys[i],
            );
          } else if (
            eventListenerObject[layerIndex][objectKeys[i]].object.visible
          ) {
            raycasterList.push(
              eventListenerObject[layerIndex][objectKeys[i]].object,
            );
          }
        }
      }

      const intersects = raycaster.intersectObjects(raycasterList, false);

      if (intersects.length === 0) {
        return;
      }

      // eventListenerObject[intersects[0].object.uuid][eventsName.MOVE](
      //   intersects[0].object,
      // );
      processAction(intersects, layerIndex);
      hasHovered = true;
    }
  });
  if (!hasHovered) {
    setHoveredObject(undefined);
    return;
  }
}
function onMouseDown(mouseInfo) {
  let hasFound = false;
  layers.forEach(layerIndex => {
    if (!hasFound) {
      if (Object.keys(eventListenerObject[layerIndex]).length === 0) {
        return;
      }

      let rect = webGLRenderer.domElement.getBoundingClientRect();

      pointer.x =
        ((mouseInfo.clientX - rect.left) / (window.innerWidth - rect.left)) *
          2 -
        1;
      pointer.y =
        -((mouseInfo.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;

      const objectKeys = Object.keys(eventListenerObject[layerIndex]);
      raycaster.setFromCamera(pointer, scene.children[activeCameraIndex]);
      let raycasterList = [];
      for (let i = 0; i < objectKeys.length; i++) {
        if (
          eventListenerObject[layerIndex][objectKeys[i]].hasOwnProperty(
            eventsName.DOWN,
          ) ||
          eventListenerObject[layerIndex][objectKeys[i]].hasOwnProperty(
            eventsName.HOLD,
          )
        ) {
          if (!eventListenerObject[layerIndex][objectKeys[i]].object.name) {
            eventListenerObject[layerIndex][objectKeys[i]][eventsName.DOWN](
              objectKeys[i],
            );
          } else if (
            isVisible(eventListenerObject[layerIndex][objectKeys[i]].object)
          ) {
            raycasterList.push(
              eventListenerObject[layerIndex][objectKeys[i]].object,
            );
          }
        }
      }
      const intersects = raycaster.intersectObjects(raycasterList, false);
      if (intersects.length === 0) {
        return;
      }
      if (
        eventListenerObject[layerIndex][
          intersects[0].object.uuid
        ].hasOwnProperty(eventsName.DOWN)
      ) {
        eventListenerObject[layerIndex][intersects[0].object.uuid][
          eventsName.DOWN
        ](intersects[0]);
      }
      if (
        eventListenerObject[layerIndex][
          intersects[0].object.uuid
        ]?.hasOwnProperty(eventsName.HOLD)
      ) {
        holdTimeOut = setTimeout(() => {
          onMouseHold(mouseInfo, intersects[0]);
        }, holdTimeToStart);
      }
      hasFound = true;
    }
  });
}

function onMouseHold(mouseInfo, previousRayCast) {
  layers.forEach(layerIndex => {
    let rect = webGLRenderer.domElement.getBoundingClientRect();

    pointer.x =
      ((mouseInfo.clientX - rect.left) / (window.innerWidth - rect.left)) * 2 -
      1;
    pointer.y =
      -((mouseInfo.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
    const objectKeys = Object.keys(eventListenerObject[layerIndex]);
    raycaster.setFromCamera(pointer, scene.children[activeCameraIndex]);
    let raycasterList = [];
    for (let i = 0; i < objectKeys.length; i++) {
      if (
        eventListenerObject[layerIndex][objectKeys[i]].hasOwnProperty(
          eventsName.HOLD,
        )
      ) {
        raycasterList.push(
          eventListenerObject[layerIndex][objectKeys[i]].object,
        );
      }
    }
    const intersects = raycaster.intersectObjects(raycasterList, false);
    if (intersects.length === 0) {
      return;
    }
    if (previousRayCast.object.uuid === intersects[0].object.uuid)
      eventListenerObject[layerIndex][intersects[0].object.uuid][
        eventsName.HOLD
      ](intersects[0]);
  });
}

function onMouseUp(mouseInfo) {
  layers.forEach(layerIndex => {
    if (Object.keys(eventListenerObject[layerIndex]).length === 0) {
      return;
    }
    clearTimeout(holdTimeOut);

    let rect = webGLRenderer.domElement.getBoundingClientRect();

    pointer.x =
      ((mouseInfo.clientX - rect.left) / (window.innerWidth - rect.left)) * 2 -
      1;
    pointer.y =
      -((mouseInfo.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
    const objectKeys = Object.keys(eventListenerObject[layerIndex]);
    raycaster.setFromCamera(pointer, scene.children[activeCameraIndex]);
    let raycasterList = [];
    for (let i = 0; i < objectKeys.length; i++) {
      if (
        eventListenerObject[layerIndex][objectKeys[i]].hasOwnProperty(
          eventsName.UP,
        )
      ) {
        if (!eventListenerObject[layerIndex][objectKeys[i]].object.name) {
          eventListenerObject[layerIndex][objectKeys[i]][eventsName.UP]();
        } else {
          raycasterList.push(
            eventListenerObject[layerIndex][objectKeys[i]].object,
          );
        }
      }
    }
    const intersects = raycaster.intersectObjects(raycasterList, false);
    if (intersects.length === 0) {
      return;
    }
    eventListenerObject[layerIndex][intersects[0].object.uuid][eventsName.UP](
      intersects[0],
    );
  });
}

function setHoveredObject(raycastInfo, layerIndex = 0) {
  if (hoveredObject) {
    onMouseHoverEnd(hoveredObject);
  }
  hoveredObject = raycastInfo?.object;
  onMouseHoverStart(hoveredObject, layerIndex);
}

function onMouseHoverStart(raycastInfo, layerIndex) {
  if (!raycastInfo) {
    return;
  }
  if (eventListenerObject[layerIndex][raycastInfo.uuid]?.mouseover) {
    eventListenerObject[layerIndex][raycastInfo.uuid][eventsName.HOVER](
      raycastInfo,
    );
  }
}

function onMouseHoverEnd(raycastInfo) {
  layers.forEach(layerIndex => {
    if (eventListenerObject[layerIndex][raycastInfo.uuid]?.mouseout) {
      eventListenerObject[layerIndex][raycastInfo.uuid][eventsName.OUT](
        raycastInfo,
      );
    }
  });
}

function processAction(intersects, layerIndex) {
  if (hoveredObject) {
    if (intersects[0].object.uuid === hoveredObject.uuid) {
    } else {
      setHoveredObject(intersects[0], layerIndex);
    }
  } else {
    setHoveredObject(intersects[0], layerIndex);
  }
}

export function clearAllListeners(layerIndex = -1) {
  if (layerIndex === -1) {
    layers.forEach(layerIndex => {
      Object.keys(eventListenerObject[layerIndex]).forEach(key => {
        delete eventListenerObject[layerIndex][key];
      });
    });
  } else {
    Object.keys(eventListenerObject[layerIndex]).forEach(key => {
      delete eventListenerObject[layerIndex][key];
    });
  }
}

export function removeListenersFrom(object) {
  if (typeof object === "string") {
    layers.forEach(layerIndex => {
      if (eventListenerObject[layerIndex].hasOwnProperty(object)) {
        delete eventListenerObject[layerIndex][object];
      }
    });
  } else {
    layers.forEach(layerIndex => {
      if (eventListenerObject[layerIndex].hasOwnProperty(object.uuid)) {
        delete eventListenerObject[layerIndex][object.uuid];
      }
    });
  }
}
